import React from 'react';
import { useRouter } from 'next/navigation';
import { Auth, SeoHead } from '../components';
import Landing from '../components/landing/Landing';

export default function HomePage() {
  const router = useRouter();
  const [auth, setAuth] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!auth) {
      router.push('https://funnel.spacars.app');
    }
  }, [auth]);

  return (
    <>
      <SeoHead title="Spacars" />
      <Auth setAuth={setAuth} />
      {!auth ? <Landing /> : null}
    </>
  );
}
